module.exports = __webpack_public_path__ + "static/media/proi-solucoes.093e93ab.webp";